import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  resolveCallProvider,
  isWhatsappCallsUiEnabledForProvider,
  isWhatsappCallsAvailableForRetailer,
  isWhatsappCallsConnectedForRetailer
} from './resolveCallProvider';

/** @typedef {'fonema'|'voice'|null} CallProvider */

/**
 * @returns {CallProvider}
 */
export default function useCallProvider() {
  const retailerInfo = useSelector((state) => state.retailerUsersReducer.retailer_info);

  return useMemo(
    () => resolveCallProvider(retailerInfo),
    [retailerInfo]
  );
}

/**
 * Retailer con llamadas conectadas (Fonema o Voice con SIP).
 * @returns {boolean}
 */
export function useWhatsappCallsConnected() {
  const retailerInfo = useSelector((state) => state.retailerUsersReducer.retailer_info);

  return useMemo(
    () => isWhatsappCallsConnectedForRetailer(retailerInfo),
    [retailerInfo]
  );
}

/**
 * Retailer con llamadas disponibles por rollout (no implica SIP conectado).
 * @returns {boolean}
 */
export function useWhatsappCallsAvailable() {
  const retailerInfo = useSelector((state) => state.retailerUsersReducer.retailer_info);

  return useMemo(
    () => isWhatsappCallsAvailableForRetailer(retailerInfo),
    [retailerInfo]
  );
}

/**
 * @returns {boolean}
 */
export function useWhatsappCallsUiEnabled() {
  const provider = useCallProvider();
  return isWhatsappCallsUiEnabledForProvider(provider);
}
